import { useEffect, useState } from "react";
import { getMe, updateUser } from "../../features/search/service/user-service";
import { User } from "../../shared/types/user";
import InputComponent from "../../components/input/input";
import ButtonComponent from "../../components/button/button";
import { MenuTop } from '../../components/menu/top/menu-top';
import './styles/profile.css';

export const Profile = () => {
    const [me, setMe] = useState<User | null>(null);
    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            return;
        }

        if (newPassword !== confirmPassword) {
            return;
        }

        if (newPassword.length < 6) {
            return;
        }

        if (currentPassword === newPassword) {
            return;
        }

        setLoading(true);

        try {

            const userData: User = {
                id: me?.id!,
                name: me?.name!,
                email: me?.email!,
                password: newPassword,
                role: me?.role!,
                company: me?.company!
            };

            const response = await updateUser(me?.id!, userData);
            
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');

            if(response) {
                setMe(response);
            }
        } catch (error) {
            console.error('❌ Erro ao alterar senha:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MenuTop />
            <div className="profile-container">
                <h1>Meu Perfil</h1>

                <div className="user-info-section">
                    <h2>Informações do Usuário</h2>
                    
                    <div className="info-field">
                        <label>Nome:</label>
                        <span>{me?.name || 'Carregando...'}</span>
                    </div>

                    <div className="info-field">
                        <label>Email:</label>
                        <span>{me?.email || 'Carregando...'}</span>
                    </div>

                    {me?.company && (
                        <div className="info-field">
                            <label>Empresa:</label>
                            <span>{me.company.name || 'N/A'}</span>
                        </div>
                    )}
                </div>

                <div className="change-password-section">
                    <h2>Alterar Senha</h2>

                    <InputComponent 
                        id="id-input-current-password" 
                        label="Senha Atual" 
                        type="password"
                        value={currentPassword} 
                        onChange={(event) => setCurrentPassword(event.target.value)} 
                    />

                    <InputComponent 
                        id="id-input-new-password" 
                        label="Nova Senha" 
                        type="password"
                        value={newPassword} 
                        onChange={(event) => setNewPassword(event.target.value)} 
                    />

                    <InputComponent 
                        id="id-input-confirm-password" 
                        label="Confirmar Nova Senha" 
                        type="password"
                        value={confirmPassword} 
                        onChange={(event) => setConfirmPassword(event.target.value)} 
                    />

                    <div className="password-requirements">
                        <p>A senha deve ter pelo menos 6 caracteres</p>
                    </div>

                    <div className="button-container">
                        <ButtonComponent
                            label={loading ? "Alterando..." : "Alterar Senha"}
                            onClick={handleChangePassword}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};